export const pathConstants = {
  empty: "",
  defaultRoute: "/",
  wildCard: "*",
  dashboard: "dashboard",
  routePlanning: "route-planning",
  login: "login",
  settings: "settings",
}

export const routeConstants = {
  dashboardPath: `${pathConstants.dashboard}`,
  routePlanningPath: `${pathConstants.routePlanning}`,
}
